<template>
  <div class="container lms-wrapper-two">
    
    
    <student-nav
      @route-changed="toggleNavbar(false)"
      @on-zaaval="zaavalChanged"
      :counts.sync="counts"
      :zaaval.sync="zaaval"
    >
      <!-- <course-search
        class="mg-t-40"
        :filterParams="filterParams"
        @on-search="searchCourse"
        @on-reset="onReset"
        :key="filterKey"
      /> -->
    </student-nav>

    <div class="lms-content" @click="closeLevel2()">
      <student-header ref="stdnthdr" class="filled" @toggle-navbar="toggleNavbar($event)" :navbarmode.sync="navbarMode" 
      :filterName="filterParams.name" :filterType.sync="filterParams.type" @loctype-slcd="filterParams.type=$event" @toggle-filter-drawer="toggleFilterDrawer" 
      @on-filter="doFilter(5, $event)" @loctype-cleared="loctypeCleared" :key="filterKey" />
      
      <div class="lms-content-body container " >
      
        <vue-custom-scrollbar :key="listMode"
          :class="`course-list pd-t-20-f pd-lg-x-80 pd-lg-xl-120 row ${listMode===2?'list-list': listMode===3?'list-table':''}`"
          :style="`height: calc(100vh - ${listMode === 3 ? '160px':'140px'})`"
        >
          <template v-for="(r, ci) in courses">
          
            <div class="text-muted pd-x-5 pd-y-3" v-if="isDrawGroupDateRange(ci) && listMode===3">{{r.locType.name}}</div>
            <div class="course-item col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3 pd-10">
              <div :class="`${getCourseFlagBg(r)} course-tag pos-absolute r-10 t-45 text-white pd-x-20 pd-y-1 tx-14`">
                {{getCourseFlag(r)}}
              </div>

              <div :class="`${getCourseFlagBgMust(r)} course-tag-must pos-absolute r-10 t-75 text-white pd-x-20 pd-y-1 tx-14`" 
                v-if="$route.params.md == 2 && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)">
                {{getCourseFlagMust(r)}}
              </div>
              
              <div class="bg-white pd-15 rounded-20 item-outer pos-relative">
                <div v-if="listMode==1 && r.planTypeId==1" :class="`${getCourseFlagBg(r)} pos-absolute r-0 b-0 pd-x-5 pd-y-5`" style="border-radius: 0 10px 0 10px; background-image: linear-gradient(135deg, #00a995, #002e5b)">
                  <img src="https://res.gosmart.mn/media/logo/monicpa-academy.png?w=72" /> 
                </div>
                <img :class="`cover rounded-20 wd-100p ${listMode==2?'ht-120':''}`" :src="`${r.cover}?${getCoverSize()}`" />
                <div class="item-info pd-10 d-flex align-items-center">
                  <div v-if="listMode !== 3" class="media">
                    <img
                          v-if="r.teachers != null && r.teachers.length > 0"
                          :src="`${r.teachers[0].cover}?w=60&h=60&mode=crop`"
                          :alt="r.teachers[0].name"
                          :title="r.teachers[0].name"
                          class="rounded-circle mg-r-10 wd-60 ht-60"
                        />
                        <img
                          v-else
                          src="assets/img/default.png?w=60&h=60&mode=crop"
                          alt
                          class="rounded-circle mg-r-10 wd-60 ht-60"
                        />
                  </div>
                  <div class="media-body">
                    <div :class="`course-name tx-${listMode==2?'16':'13'} font-weight-bold lh-1`" :title="r.name">{{r.name}}</div>
                    
                    <div class="d-flex align-items-center">
                      <div v-if="r.locType1!=null && listMode!==3" class="text-muted tx-10 mg-y-3">{{r.locType1.name}} <span v-if="r.myShare!=null">{{r.myShare.percent}}</span></div>
                      <div v-if="r?.price > 0" :class="`${listMode===3?'mg-l-5':'ml-auto'}`">{{ parseFloat(r.price) | formatMoney(0, ".", ",") }}<span class="text-muted"> ₮</span></div>
                      <div v-else :class="`${listMode===3?'mg-l-5':'ml-auto'} text-muted`">үнэгүй</div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div v-if="r.option.hideRegisteredCount!=undefined && r.option.hideRegisteredCount==1 && listMode!==3">
                        <img class="ht-15 wd-15  " :src="`${myResBaseUrl}v4-assets/svgicon/user/outline/user.svg`" /> <span class="tx-10 text-muted">{{r.userCount}}</span>
                      </div>
                      <div :class="`${listMode!==3 ? 'mg-l-10':''}`">
                        <Rate v-model="r.rate" :allow-half="true" :disabled="true" size="large" ></Rate>
                      </div>
                      <div v-if="listMode === 3 && r.myShare?.percent>0" class="d-flex mg-l-10 align-items-center gap-1">
                        <div class="progress ht-15" style="width: 100px">
                          <div class="progress-bar wd-25p" :style="`width: ${r.myShare?.percent}%`" role="progressbar"></div>
                        </div>
                        <span class="text-muted">{{ r.myShare?.finishedLessonCount }}/{{r.lessonCount}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="course-view justify-content-center align-items-center mg-l-auto ">
                <!-- {{ $route.params.md }} -->
                  <div v-if="$route.params.md == 1 || $route.params.md == 11" class="btn-group rounded-20">
                    <template v-if="r.myShare != null">
                      <!-- <router-link v-if="r.firstLessonId > 0" :to="{ name: 'lmsLessonView', params: { id: r.firstLessonId, cid: r.id, bid: 0, iid: 0, bot: 0 } }" class="btn btn-white ">Үзэх</router-link>  
                      <router-link v-else :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" class="btn btn-white ">Дэлгэрэнгүй</router-link>   -->
                      <router-link :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" class="btn btn-white">{{r.firstLessonId > 0?'Үзэх':'Үзэх'}}</router-link>  
                    </template>
                    <!-- <button v-else @click="courseInfo(r)" type="button" class="btn btn-white ">
                      {{r.option.joinType == 9900 || r.option.directJoin == 1 ? "Элсэх" : "Бүртгүүлэх"}}
                    </button> -->
                    <button v-else-if="r.option!=undefined && r.option!=null && ((r.option.joinType == 9900 && r.price == 0 && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)) || r.option.directJoin == 1)" 
                      class="btn btn-white" @click="beforeJoinToCourse(r)" role="button">
                      Үзэх
                    </button>
                    <router-link v-else class="btn btn-white" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">
                      <!-- {{r.option.joinType == 9900 || r.option.directJoin == 1 ? "Элсэх" : "Бүртгүүлэх"}} -->
                      {{ $store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249 ?'Үзэх':'Танилцах' }}
                    </router-link>
                    <!-- <button @click="courseInfo(r)" type="button" class="btn btn-white ">Танилцах</button> -->
                  </div>
                  <div v-else-if="$route.params.md == 2" class="btn-group rounded-20">                  
                    <template v-if="r.myShare != null">
                      <!-- <router-link v-if="r.firstLessonId>0" class="btn btn-white rounded-20" :to="{ name: 'lmsLessonView', params: { id: r.firstLessonId, cid: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">Үзэх</router-link>
                      <router-link v-else class="btn btn-white rounded-20" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">Дэлгэрэнгүй</router-link> -->

                      <router-link class="btn btn-white rounded-20" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">{{r.firstLessonId>0?'Үзэх':'Үзэх'}}</router-link>
                    </template>
                    <!-- <button v-else @click="courseInfo(r)" class="btn btn-white rounded-20" type="button" >Элсэх</button> -->
                    <button v-else-if="r.option!=undefined && r.option!=null && ((r.option.joinType == 9900 && r.price == 0 && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)) || r.option.directJoin == 1)" 
                      class="btn btn-white" @click="beforeJoinToCourse(r)" role="button">
                      Үзэх
                    </button>
                    <router-link v-else class="btn btn-white rounded-20" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">
                      Үзэх
                    </router-link>
                    <!-- <button @click="courseInfo(r)" class="btn btn-white rounded-20" type="button">Танилцах</button> -->
                  </div>
                  <div v-else-if="$route.params.md == 3 || $route.params.md == 33" class="btn-group rounded-20">
                    <template v-if="r.myShare!=null">
                      <!-- <router-link v-if="r.firstLessonId>0" class="btn btn-white rounded-20" :to="{ name: 'lmsLessonView', params: { id: r.firstLessonId, cid: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">Үзэх</router-link>
                      <router-link v-else class="btn btn-white rounded-20" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">Дэлгэрэнгүй</router-link> -->
                      
                      <router-link class="btn btn-white rounded-20" :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button">{{r.firstLessonId>0?'Үзэх':'Үзэх'}}</router-link>
                    </template>
                    <!-- <button v-else class="btn btn-white rounded-20" @click="courseInfo(r)" type="button">Тухай</button> -->
                  </div>
                  <div v-else-if="$route.params.md == 4 || $route.params.md == 44" class="btn-group btn-group-lg rounded-20">
                    <button v-if="r.certificateView" @click="showCertificate(r)" class="btn btn-white rounded-20">Сертификат</button>
                    
                    <template v-if=" r.option.canViewAfterFinish != undefined && r.option.canViewAfterFinish ">
                      <!-- <router-link v-if="r.firstLessonId>0" :to="{ name: 'lmsLessonView', params: { id: r.firstLessonId, cid: r.id, bid: 0, iid: 0, bot: 0 } }" type="button" class="btn btn-white rounded-20">
                        Үзэх
                      </router-link>
                      <router-link v-else :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button" class="btn btn-white rounded-20">
                        Дэлгэрэнгүй
                      </router-link> -->

                      <router-link :to="{ name: 'lmsCourseView', params: { id: r.id, bid: 0, iid: 0, bot: 0 } }" type="button" class="btn btn-white rounded-20">
                        {{r.firstLessonId>0?'Үзэх':'Үзэх'}}
                      </router-link>
                    </template>
                    <button v-if="r.option.canViewExamResult" @click="showMark(r)" class="btn btn-white " type="button">Дүн харах</button>
                  </div>
                </div>
              </div>
            </div>

          </template>


          <div v-if="courses.length == 0" class="col-12 tx-color-01">
            {{fetching?'Түр хүлээнэ үү ...':'Мэдээлэл хоосон байна'}}
            
          </div>
          <div
            v-else
            v-for="(r, ci) in courses"
            :key="ci"
            class="col-xs-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 col-xxl-3 courses d-none"
          >
            <div class="card card-profile">
              <button
                v-if="r.locType1 != null"
                :class="
                  `btn btn-xs pd-x-15 btn-uppercase rounded-pill pos-absolute l-10 t-10 btn-${
                    $store.state.app.skin.dark ? 'dark' : 'white'
                  }`
                "
              >
                {{ r.locType1.name }}
              </button>
              <img
                :src="`${r.cover}?w=600`"
                class="card-img-top"
                alt="..."
                style="min-height: 200px !important"
              />
              <div class="card-body">
                <div class="mt-n70px" v-show="r.teachers.length>0">
                  <a>
                    <div class="avatar avatar-xxl">
                      <img
                        v-if="r.teachers != null && r.teachers.length > 0"
                        :src="`${r.teachers[0].cover}?w=164&h=164&mode=crop`"
                        :alt="r.teachers[0].name"
                        :title="r.teachers[0].name"
                        class="rounded-circle img-thumbnail border-0 pd-0-f"
                      />
                      <img
                        v-else
                        src="assets/img/default.png?w=144&h=144&mode=crop"
                        alt
                        class="rounded-circle img-thumbnail border-0 pd-0-f"
                      />
                    </div>
                  </a>
                </div>
                <section>
                  <h5
                    class="course-name text-truncate tx-14-f"
                    style="white-space: normal; max-height: 40px; min-height: 40px"
                  >
                    {{ r.name }}
                  </h5>
                </section>
                <section v-if="r.myShare != null" class="mg-t-10">
                  <div class="progress ht-10 mg-b-5">
                    <div
                      role="progressbar"
                      class="progress-bar bg-success"
                      :style="{ width: r.myShare.percent + '%' }"
                    ></div>
                  </div>
                  <div class="d-flex justify-content-between text-muted tx-12">
                    <span
                      >{{ r.myShare.finishedLessonCount }}/{{
                        r.lessonCount
                      }}
                      Биелүүлсэн</span
                    >
                    <span>{{ r.myShare.percent }}%</span>
                  </div>
                </section>
                <section
                  v-else
                  class="mg-t-10"
                  :title="`${r.startDate} - ${r.endDate}`"
                >
                  <div class="progress ht-10 mg-b-5">
                    <div
                      role="progressbar"
                      class="progress-bar bg-warning"
                      :style="{ width: getRemainingPercent(r) + '%' }"
                    ></div>
                  </div>
                  <div class="d-flex justify-content-between text-muted tx-12">
                    <span>Сургалт хаагдахад</span>
                    <span>{{ getRemainingDays(r) }} хоног</span>
                  </div>
                </section>
                <section class="col-12 tx-12 mg-t-10 card-text">
                  <template v-if="r.option.timeCalculationMethod == 9">
                    <div class="d-flex align-items-center">
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Үргэлжлэх хугацаа</span
                      >
                      <span class="mg-l-auto">
                        <span class="tx-primary font-weight-bold">{{
                          r.days
                        }}</span>
                        хоног
                      </span>
                    </div>
                    <div
                      v-if="r.myShare != null"
                      class="d-flex align-items-center mg-t-10"
                    >
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Дуусах огноо</span
                      >
                      <span class="tx-primary font-weight-bold mg-l-auto">{{
                        r.endDate | moment("YYYY/MM/DD")
                      }}</span>
                    </div>
                    <div v-else class="d-flex align-items-center mg-t-10">
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Үзэх хичээл</span
                      >
                      <span class="tx-primary font-weight-bold mg-l-auto">{{
                        r.lessonCount
                      }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="d-flex align-items-center">
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Эхлэх огноо</span
                      >
                      <span class="tx-primary font-weight-bold mg-l-auto">{{
                        r.startDate | moment("YYYY/MM/DD")
                      }}</span>
                    </div>
                    <div class="d-flex align-items-center mg-t-10">
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Дуусах огноо</span
                      >
                      <span class="tx-primary font-weight-bold mg-l-auto">{{
                        r.endDate | moment("YYYY/MM/DD")
                      }}</span>
                    </div>
                  </template>
                </section>
                <section class="ht-35">
                  <div
                    v-if="$route.params.md == 1 || $route.params.md == 11"
                    class="btn-group btn-group wd-100p"
                    role="group"
                  >
                    <router-link
                      v-if="r.myShare != null"
                      :to="{
                        name: 'lmsCourseView',
                        params: { id: r.id, bid: 0, iid: 0, bot: 0 }
                      }"
                      type="button"
                      class="btn btn-success wd-50p"
                      >Үзэх</router-link
                    >
                    <button
                      v-else
                      @click="courseInfo(r)"
                      type="button"
                      class="btn btn-primary wd-50p"
                    >
                      {{
                        (r.option.joinType == 9900 && r.price == 0) || r.option.directJoin == 1
                          ? "Элсэх"
                          : "Бүртгүүлэх"
                      }}
                    </button>
                    <!-- <button
                      @click="courseInfo(r)"
                      type="button"
                      :class="
                        `btn bd-0 wd-50p btn-${
                          $store.state.app.skin.dark ? 'dark' : 'light'
                        }`
                      "
                    >
                      Танилцах
                    </button> -->
                  </div>
                  <div
                    v-else-if="$route.params.md == 2"
                    class="btn-group wd-100p"
                    role="group"
                  >
                    <router-link
                      v-if="r.myShare != null"
                      :to="{
                        name: 'lmsCourseView',
                        params: { id: r.id, bid: 0, iid: 0, bot: 0 }
                      }"
                      type="button"
                      class="btn btn-success wd-50p"
                      >Үзэх</router-link
                    >
                    <button
                      v-else
                      @click="courseInfo(r)"
                      type="button"
                      class="btn btn-primary wd-50p"
                    >
                      Элсэх
                    </button>
                    <!-- <button
                      @click="courseInfo(r)"
                      type="button"
                      :class="
                        `btn bd-0 wd-50p btn-${
                          $store.state.app.skin.dark ? 'dark' : 'light'
                        }`
                      "
                    >
                      Танилцах
                    </button> -->
                  </div>
                  <div
                    v-else-if="$route.params.md == 3 || $route.params.md == 33"
                    class="btn-group btn-group-sm wd-100p"
                    role="group"
                  >
                    <router-link
                      :to="{
                        name: 'lmsCourseView',
                        params: { id: r.id, bid: 0, iid: 0, bot: 0 }
                      }"
                      type="button"
                      class="btn btn-success wd-50p"
                      >Үзэх</router-link
                    >
                    <button
                      @click="courseInfo(r)"
                      type="button"
                      :class="
                        `btn bd-0 wd-50p btn-${
                          $store.state.app.skin.dark ? 'dark' : 'light'
                        }`
                      "
                    >
                      Тухай
                    </button>
                  </div>
                  <div
                    v-else-if="$route.params.md == 4 || $route.params.md == 44"
                    class="btn-group btn-group-sm wd-100p"
                    role="group"
                  >
                    <button
                      v-if="r.certificateView"
                      @click="showCertificate(r)"
                      type="button"
                      class="btn btn-lg btn-success wd-50p"
                    >
                      Сертификат
                    </button>
                    <router-link
                      v-if="
                        r.option.canViewAfterFinish != undefined &&
                          r.option.canViewAfterFinish
                      "
                      :to="{
                        name: 'lmsCourseView',
                        params: { id: r.id, bid: 0, iid: 0, bot: 0 }
                      }"
                      type="button"
                      class="btn btn-primary wd-50p text-white"
                      >Үзэх</router-link
                    >
                    <button
                      v-if="r.option.canViewExamResult"
                      @click="showMark(r)"
                      type="button"
                      class="btn btn-primary wd-50p"
                    >
                      Дүн харах
                    </button>
                  </div>
                </section>
              </div>
              <div
                class="marker-icon marker-top-right marker-primary pos-absolute t--0 r--0"
                v-if="r.option.joinType == 9900"
              >
                <feather
                  class="mg-l-20 mt-n3"
                  style="overflow: initial"
                  type="star"
                  :size="16"
                ></feather>
              </div>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
      <div class="lms-content-footer">
        <div class="font-weight-bold pd-l-20 tx-16 d-none d-md-block ">Нийт {{courses.length}} сургалт</div>
        <div class="d-flex align-items-center">
          <div class="mg-r-10">
            <Select v-model="sortParams.mode" size="small" placeholder="Эрэмбэлэх" @change="doSort" clearable>
              <Option label="А-Я" value="name_asc"></Option>
              <Option label="Я-А" value="name_desc"></Option>
              <Option label="Төлбөр ихээс бага руу" value="price_desc"></Option>
              <Option label="Төлбөр багаас их рүү" value="price_asc"></Option>
            </Select>
          </div>
          <div class="mg-r-10">
            <loc-type-cascader v-if="$store.state.app.activeGroup.id !== 9358" @input="doFilter(22, $event)" v-model="filterParams.locTypeId2" placeholder="Түвшин"
            @loctype-selected_withdata="loctypeSelectedWithdata"
            :id="parseInt(filterParams.locTypeId2, 10)" :key="filterParams.locTypeId2" 
            locTypekey="courseLvl" size="small" disableAdd class="wd-100p-f"  @loctype-cleared="courseLvlCleared"/>
          </div>
          <!-- <div class="list-switcher bg-white rounded btn-group">
            <a @click="listMode=2" class="btn d-flex align-items-center" :class="{ active: listMode==2}">
              <img :src="`${myResBaseUrl}v4-assets/svgicon/menu/solid/menu-line-horizontal.svg`" />
              <span>Жагсаалт</span>
            </a>
            <a @click="listMode=1" class="btn d-flex align-items-center bd-l" :class="{ active: listMode==1}">
              <img :src="`${myResBaseUrl}v4-assets/svgicon/menu/solid/apps 01.svg`" /> 
              <span>Карт</span>
            </a>
          </div> -->
          <div class="btn-group btn-group-sm" role="group">
            <button v-if="$store.state.app.activeGroup.id !== 9358" @click="listMode=2" type="button" :class="`btn btn-${listMode===2?'white': 'light'}`">Жагсаалт</button>
            <button @click="listMode=1" type="button" :class="`btn btn-${listMode===1?'white': 'light'}`">Карт</button>
            <button @click="changeListMode(3)" type="button" :class="`btn btn-${listMode===3?'white': 'light'}`">Хүснэгт</button>
          </div>
        </div>
        <div class="pd-r-10">
          <a @click="filterParams.sideBar=true" class="btn btn-primary rounded-20 text-white"><feather type="filter"></feather> шүүх</a>
        </div>
      </div>
      <div @click="filterParams.sideBar=false" class="lms-content-backdrop" :class="{open : filterParams.sideBar }"></div>
      <div class="lms-content-sidebar" :class="{open : filterParams.sideBar }">
        <div class="bd-b d-flex align-items-center bg-light pd-l-20">
          <div class="font-weight-bolder text-uppercase">Шүүх</div>
          <a class="btn btn-icon mg-l-auto" @click="filterParams.sideBar=false">
            <img :src="`${myResBaseUrl}v4-assets/svgicon/interface/bulk/remove 01.svg`" />
          </a>
        </div>
        <div class="pd-y-20 pd-x-10">
          <div class="bd-b pd-b-10">
            <div class="pd-b-10 tx-12 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10">Сургалтын төлөв</div>
            <nav class="nav nav-sidebar tx-14 mg-l-10">
              <a @click="doFilter(1,1)" class="nav-link" :class="{active: $route.params.md==1 }">
                <img :src="`${myResBaseUrl}v4-assets/svgicon/arrows/solid/arrow-left.svg`" class="mg-r-10" /> <span>Бүх нээлттэй сүргалт</span>
              </a>
              <a @click="doFilter(1,2)" class="nav-link" :class="{active: $route.params.md==2 }">
                <img :src="`${myResBaseUrl}v4-assets/svgicon/arrows/solid/arrow-left.svg`" class="mg-r-10" /> <span>Заавал хамрагдах сургалт</span>
              </a>
              <a @click="doFilter(1,3)" class="nav-link" :class="{active: $route.params.md==3 }">
                <img :src="`${myResBaseUrl}v4-assets/svgicon/arrows/solid/arrow-left.svg`" class="mg-r-10" /> <span>Миний үзэж буй сургалт</span>
              </a>
              <a @click="doFilter(1,4)" class="nav-link" :class="{active: $route.params.md==4 }">
                <img :src="`${myResBaseUrl}v4-assets/svgicon/arrows/solid/arrow-left.svg`" class="mg-r-10" /> <span>Миний дууссан сургалт</span>
              </a>
            </nav>
          </div>
          <div class="pd-y-10 bd-b">
            <div class="pd-b-10 tx-12 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10">Түвшин</div>
            <div class="pd-l-10">
              <loc-type-cascader @input="doFilter(22, $event)" v-model="filterParams.locTypeId2" :id="parseInt(filterParams.locTypeId2, 10)" :key="filterParams.locTypeId2" locTypekey="courseLvl" disableAdd class="wd-100p-f" />
            </div>
          </div>

          <div class="pd-y-10 bd-b">
            <div class="pd-b-10 tx-12 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10">Сургалтын төрөл</div>
            <div class="pd-l-10">
              <loc-type-cascader @input="doFilter(2, $event)" v-model="filterParams.type" :id="parseInt(filterParams.type, 10)" :key="filterParams.type" locTypekey="courseType" disableAdd class="wd-100p-f" />
            </div>
          </div>
          <div class="pd-y-10 bd-b">
            <div class="pd-b-10 tx-12 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10">Сургалтын нэр</div>
            <div class="pd-l-10">
              <Input @input="doFilterDebounced" v-model="filterParams.name" placeholder="Хайх нэрээ бичнэ үү" />
            </div>
          </div>
          <div class="pd-y-10">
            <div class="pd-b-10 tx-12 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10">Сургалтын хугацаа</div>
            <div class="pd-l-10">
              <date-picker @input="doFilter(4, $event)" class="wd-100p-f" v-model="filterParams.date" type="daterange" range-separator="To" start-placeholder="Эхлэх огноо" end-placeholder="Дуусах огноо" ></date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <b-sidebar
      v-model="filterParams.sideBar"
      title="Шүүх"
      shadow
      right
      width="100%"
    >
      <div class="px-3 py-2 bg-white">
        <div class="row">
          <div class="col-12">
            <date-picker
              class="wd-100p"
              v-model="filterParams.date"
              type="daterange"
              range-separator="To"
              start-placeholder="Эхлэх огноо"
              end-placeholder="Дуусах огноо"
            ></date-picker>
          </div>
          <div class="col-12">
            <Select
              placeholder="Төрөл"
              v-model="filterParams.type"
              class="wd-100p"
            >
              <Option :value="null">Бүгд</Option>
            </Select>
          </div>
          <div class="col-12">
            <Input
              v-model="filterParams.name"
              placeholder="Хайх нэрээ бичнэ үү"
            />
          </div>
        </div>
        <button class="btn btn-primary btn-block">Шүүх</button>
      </div>
    </b-sidebar> -->
    <b-modal v-model="updateMngNameModal.show" no-close-on-backdrop hide-header>
      <div
        class="
          ht-100p
          d-flex
          flex-column
          justify-content-center
          pd-20 pd-sm-30 pd-md-40
        "
      >
        <span class="tx-color-04">
          <feather type="award" :size="32"></feather>
        </span>
        <h3 class="tx-16 tx-sm-20 tx-md-24 mg-b-15 mg-md-b-20">
          Овог нэрээ монгол бичгээр оруулна уу
        </h3>
        <div>
          Сертификатад хэвлэгдэх өөрийн нэрийг бичихдээ компьютерийн хэлийг English-р тохируулж, CMs Ulaanbaatar фонтын галигаар галиглаж бичнэ үү.
        </div>
        
        <div class="d-flex">
          <form class="pd-20" >
            <div class="form-group mg-b-0 row">
              <label class="col-form-label pd-t-20 d-block">Овог</label>
              <input
                v-model="updateMngNameModal.mngLastName"
                maxlength="50"
                class="form-control"
                placeholder="Овог"
              />
              <div style="font-family: 'CMs Ulaanbaatar'">{{updateMngNameModal.mngLastName}}</div>
            </div>
            <div class="form-group mg-b-0 row">
              <label class="col-form-label pd-t-20 d-block">Нэр</label>
              <input
                v-model="updateMngNameModal.mngFirstName"
                maxlength="50"
                class="form-control"
                placeholder="Нэр"
              />
              <div style="font-family: 'CMs Ulaanbaatar'">{{updateMngNameModal.mngFirstName}}</div>
            </div>
          </form>
        </div>
      </div>
      <template #modal-footer>
        <div class="mg-l-auto">
          <b-button @click="updateMngName()" variant="success">Хадгалах</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="course.modal"
      size="lg"
      centered
      :title="course.obj.name"
      scrollable
    >
      <div class="mg-x-20" v-if="course.modal">
        <!-- <h6 class="mg-b-20">{{course.obj.name}}</h6> -->

        <b-carousel
          v-if="course.obj.teachers.length"
          :interval="4000"
          indicators
          class="ht-200 teachers-carousel"
        >
          <b-carousel-slide
            v-for="(t, i) in course.obj.teachers"
            :key="i"
            img-blank
          >
            <template #img>
              <div class="d-flex">
                <div>
                  <img
                    :src="`${t.cover}?w=144&h=144&mode=pad`"
                    alt
                    class="img-thumbnail border-0 pd-0-f"
                  />
                </div>
                <div class="mg-l-10 pd-t-20">
                  <h6>{{ t.lastName }} {{ t.firstName }}</h6>
                  <p class="mg-b-2 text-muted">Газар нэгж: {{ t.depart }}</p>
                  <p class="mg-b-2 text-muted">
                    Албан тушаал: {{ t.position }}
                  </p>
                  <p class="mg-b-0 text-muted">И мэйл хаяг: {{ t.email }}</p>
                </div>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>

        <div class="card mg-t-20">
          <div class="card-body text-left bd">
            <h6 class="bd-l bd-5 bd-gray-500 pd-l-5">Сургалтын агуулга:</h6>
            <p class="gosm-edtr-outer" v-html="course.obj.info"></p>
          </div>
        </div>

        <div class="card mg-t-20">
          <div class="card-body text-left bd">
            <h6 class="bd-l bd-5 bd-gray-500 pd-l-5">Судлах модулиуд:</h6>
            <ol class="mg-l-20">
              <li v-for="(l, i) in course.lessons" :key="i" >
                <div class="d-flex bd-b mg-b-5">
                  {{ l.task }}
                  <a @click="infModule(l)" class="mg-l-auto tx-medium" role="button">
                    Дэлгэрэнгүй
                    <i class="icon ion-md-arrow-forward mg-l-5"></i>
                  </a>
                </div>
              </li>
            </ol>
          </div>
        </div>

        <div class="row">
          <div
            v-for="(c, ii) in course.infos"
            :key="ii"
            class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
          >
            <div class="card">
              <div class="card-body bd">
                <div class="media">
                  <div class="mg-r-20">
                    <feather :type="c.icon"></feather>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                    >
                      {{ c.title }}
                    </h6>
                    <h6 class="tx-13 tx-normal mg-b-0">{{ c.value }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="text-center wd-100p">
          <router-link
            :to="{
              name: 'lmsCourseView',
              params: { id: course.obj.id, bid: 0, iid: 0, bot: 0 }
            }"
            v-if="course.obj.isJoined"
            class="btn btn-sm pd-x-15 btn-success btn-uppercase"
            >Үзэх</router-link
          >
          <router-link
            :to="{
              name: 'lmsAttend',
              params: { id: course.obj.id, s1: 0, s2: 0 }
            }"
            v-else-if="course.obj.option.joinType == 9900 && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249) && course.obj.price == 0"
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
            >Элсэх</router-link
          >
          <button
            @click="directJoinToCourse(course.obj)"
            v-else-if="course.obj.option.directJoin == 1"
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
          >
            Элсэх
          </button>
          <router-link
            :to="{
              name: 'lmsAttend',
              params: { id: course.obj.id, s1: 0, s2: 0 }
            }"
            v-else
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
            >Бүртгүүлэх</router-link
          >
        </div>
      </template>
    </b-modal>
    
    <b-modal v-model="certificateModal.show" hide-footer hide-header>
      <div
        class="ht-100p d-flex flex-column justify-content-center pd-20 pd-sm-30 pd-md-40"
      >
        <span class="tx-color-04">
          <feather type="award" :size="32"></feather>
        </span>
        <h3 class="tx-16 tx-sm-20 tx-md-24 mg-b-15 mg-md-b-20">
          {{ certificateModal.title }}
        </h3>
        <p
          class="tx-14 tx-md-16 tx-color-02"
          v-html="certificateModal.text"
        ></p>
        
        <div v-if="certificateModal.show" class="d-flex btn-group">
          <a @click="onCertificateRe" class="btn btn-warning btn-uppercase">
              Сертификат шинэчлэх
            </a>
          <a :href="certificateModal.url" target="_blank"
            class="btn btn-success btn-uppercase"
            >Сертификат татаж авах</a>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="courseExamResult.show" hide-footer hide-header>
      <div
        class="ht-100p d-flex flex-column justify-content-center pd-20 pd-sm-30 pd-md-40"
      >
        <span class="tx-color-04">
          <feather type="award" :size="32"></feather>
        </span>
        <h3 class="tx-16 tx-sm-20 tx-md-24 mg-b-15 mg-md-b-20">
          Шалгалтын дүн
        </h3>
        <p class="tx-22 tx-md-16 tx-color-02 text-center">
          {{ courseExamResult.result.toFixed(2) }}
        </p>

        <!-- <a
          v-if="courseExamResult.show"
          :href="certificateModal.url"
          target="_blank"
          class="btn btn-primary btn-block btn-uppercase"
        >Сертификат татаж авах</a> -->
      </div>
    </b-modal>

    <b-modal v-model="mdlInf.modal" hide-footer title="Дэлгэрэнгүй">
      <div
        class="ht-100p d-flex flex-column justify-content-center pd-20"
      >
        <h3 class="tx-16 tx-sm-20 tx-md-24">Дэлгэрэнгүй</h3>
        <p v-html="mdlInf.obj.taskDesc" class="tx-22 tx-md-16 tx-color-02"></p>
        <h3 class="tx-16 tx-sm-20 tx-md-24">Зорилго</h3>
        <p v-html="mdlInf.obj.f1" class="tx-22 tx-md-16 tx-color-02"></p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Select, Option, Input, Rate, Notification } from "element-ui";
import { mapActions } from "vuex";

import { localRead, localSave } from "@/libs/util";

var _ = require("lodash");
const moment = require("moment");

export default {
  components: {
    DatePicker,
    Select,
    Option,
    Input,
    Rate,
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseSearch: () => ({
      component: import(
        "@/views/modules/lms/student/pages/courses/components/search.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      zaaval:{
        viewing: null,
        notRegistered: null,
        completed: null,
        mode: 0,
      },
      fetching: false,
      listMode:1,
      navbarMode: 1,
      filterCourseSidebar: false,
      filterKey: 0,
      filterParams: {
        sideBar: false,
        show: false,
        activeId: 1,
        date: "",
        type: null,
        locTypeId2: null,
        name: ""
      },
      sortParams: {
        mode: 'name_asc',
      },
      now: null,
      course: {
        obj: {},
        modal: false,
        infos: [],
        lessons: []
      },
      coursesRaw: [],
      courses: [],
      counts: {
        allCount: 0,
        finishedCount: 0,
        joinedCount: 0,
        mustJoinCount: 0
      },
      certificateModal: {
        show: false,
        course: null,
        title: "",
        text: "",
        url: ""
      },
      courseExamResult: {
        show: false,
        result: 0
      },
      mdlInf:{
        modal: false,
        obj: false,
      },
      updateMngNameModal: {
        show: false,
        mngFirstName: "",
        mngLastName: "",
      },
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    // console.log('=> courses mount fired');
    // this.$store.state.app.routes.forEach((r)=>{
    //console.log('r', r.name, r.path);
    //   r.children.forEach((c)=>{
    //console.log('e', r.name, r.path, c.name, c.path);
    //   })
    // })
    //this.toggleBodyClass("addClass", "app-lms");
    //require('@/assets/scss/pages/course.scss');
    //require("@/assets/css/dynamic.lms.css");
    this.init();
  },
  beforeDestroy(){
    if(localRead("course_filter_lc2")) {
      window.localStorage.removeItem("course_filter_lc2");
    }
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    doSort(){
      this.courses = this.coursesRaw.sort((a, b) => {
        if(this.sortParams.mode == 'name_asc' || this.sortParams.mode == '' || this.sortParams.mode == null){
          return a.name.localeCompare(b.name);
        }else if(this.sortParams.mode == 'name_desc'){
          return b.name.localeCompare(a.name);
        }else if(this.sortParams.mode == 'price_asc'){
          return a.price - b.price;
        }else if(this.sortParams.mode == 'price_desc'){
          return b.price - a.price;
        }
      });
    },
    zaavalChanged(mode){
      if(mode == 0){
        this.courses = this.coursesRaw;
      }
      else if(mode == 1){
        this.courses = this.coursesRaw.filter(x=>x.myShare !== null && x.myShare.percent < 100);
      }
      else if(mode == 2){
        this.courses = this.coursesRaw.filter(x=>x.myShare === null);
      }
      else if(mode == 3){
        this.courses = this.coursesRaw.filter(x=>x.myShare !== null && x.myShare.percent >= 100);
      }
      this.zaaval.mode = mode;
    },
    ...mapActions(["resetResponsiveLayoutConfig"]),
    isDrawGroupDateRange(i) {
      let _fname = "name";
      if (i == 0) {
        return true;
      } else if (this.courses[i]['locType'][_fname] != this.courses[i - 1]['locType'][_fname]) {
        return true;
      } else {
        return false;
      }
    },
    getCoverSize(){
      let rv='';
      if(this.listMode==2){
        rv='w=200&h=120&mode=crop';

      } else if(this.listMode==3){
        rv='w=45&h=35&mode=crop';

      } else{
        if(this.$store.state.app.activeGroup.id==9157){
          rv= 'w=400&h=280&mode=pad';
          // rv= '';
        }else{
          rv= 'w=400&h=280&mode=crop';
        }

        if(this.$store.state.app.activeGroup.learnConfig!=undefined){
          if(this.$store.state.app.activeGroup.learnConfig.course!=undefined){
            if(this.$store.state.app.activeGroup.learnConfig.course.thumb!=undefined){
              if(this.$store.state.app.activeGroup.learnConfig.course.thumb.orientation=='landscape'){
                rv= `w=300&h=120&mode=${this.$store.state.app.activeGroup.learnConfig.course.thumb.mode}`;
              }
            }
          }
        }
      } 
      return rv;
    },
    getCourseFlagBg(course){
      let rv='';
      switch(this.getCourseFlag(course)){
        case "заавал хамрагдах": rv='bg-orange'; break;
        case "дууссан": rv='bg-gray-500'; break;
        case "үзэж буй": rv='bg-primary'; break;
        case "бүртгүүлээгүй": rv='bg-info'; break;
        default: break;
      }
      return rv;
    },
    getCourseFlag(course) {
      //console.log('course', course.name, course.myShare);
      let rv='';
      if(this.$route.params.md == 4 || this.$route.params.md == 44) {
        rv= 'дууссан';
        return rv;
      }

      if(course.option!=null && course.option.joinType==9900){
        rv='заавал хамрагдах';
        

        if(course.myShare!=null && course.myShare.percent>=100){
          if(this.$route.params.md == 3 || this.$route.params.md == 33) {
            rv= 'үзэж буй';
          }
          else if(this.$route.params.md == 4 || this.$route.params.md == 44) {
            rv= 'дууссан';
          }
          // if((course.myShare!=null && course.myShare.percent>=100)){
          //   rv='дууссан4';
          // }
          //rv='дууссан3';
        }
      }
      else if(course.myShare!=null){
        if(course.myShare.percent>=100 || this.$route.params.md == 4 || this.$route.params.md == 44){
          rv='дууссан';
        } else {
          rv='үзэж буй';
        }
      } else {
        rv='бүртгүүлээгүй';
      }
      return rv;
    },
    getCourseFlagBgMust(course){
      let rv='';
      switch(this.getCourseFlagMust(course)){
        case "дууссан": rv='bg-gray-500'; break;
        case "үзэж буй": rv='bg-primary'; break;
        case "бүртгүүлээгүй": rv='bg-info'; break;
        default: break;
      }
      return rv;
    },
    getCourseFlagMust(course){
      let rv='';
      if(course.myShare!=null && course.myShare.percent>=100){
        rv= 'дууссан';
      }
      else if(course.myShare!=null && course.myShare.percent<100){
        rv= 'үзэж буй';
      }
      else{
        rv= 'бүртгүүлээгүй';
      }
      return rv;
    },
    onHeaderFiltered(e){
      //console.log('onHeaderFiltered', e);
    },
    doFilterDebounced: _.debounce(function (e) {
      this.doFilter(3, e);
    }, 1000),
    courseLvlCleared(e){
      let self= this;
      //console.log('courseLvlCleared', e);
      window.localStorage.removeItem("course_filter_lc2");
      // this.$nextTick(()=>{
      //   this.init();
      // });
      this.filterParams.locTypeId2= null;
      // setTimeout(()=>{
        self.init();
      // },1000);
    },
    doFilter(section, value) {
      //console.log('section, value', section, value);
      let _mode= this.$route.params.md;
      let _type= -1;
      //let _locTypeId2= null;
      let _name= 'null';

      let _d1= 'null';
      let _d2= 'null';

      if(section==1){
        _mode= value;
      }
      else if(section==2){
        if(value!=null){
          _type= value;
        }
      }
      else if(section==22){
        if(value==undefined || value==null || value==0){
          window.localStorage.removeItem("course_filter_lc2");
        }else{
          localSave('course_filter_lc2', value);
          //_locTypeId2= value;
        }

        this.init();
      } else if(section==3){
        _name= value;
      } else if(section==4){
        if(value!=null){
          _d1 = moment(value[0]).format("YYYY-MM-DD");
          _d2 = moment(value[1]).format("YYYY-MM-DD");
        }
      } else if(section==5){
        //console.log('stp 1');
        //# from header search
        //if(value.type!=undefined && value.name!=undefined){
          if(value.type>0){
            //console.log('stp 2');
            _type= value.type;
            //console.log('stp 3', _type);
          }

          if(value.name!=null && value.name!=""){
            _name= value.name;
          }

          //console.log('=> ', section, value, _type)
        //}
      }

      //console.log('doFilter=> ', section, value, _type);
      // if(this.$route.params.md!=_mode || this.$route.params.cnm!=_name || this.$route.params.type!=_type || this.$route.params.d1!=_d1 || this.$route.params.d2!=_d2 ){
        // this.$router.push({
        //   name: 'lmsCourses',
        //   params: { md: _mode, cnm: _name, type: _type, d1: _d1, d2: _d2 }
        // });
      // }else{
      //   this.init();
      // }

      if(section!=22){
        this.$router.push({
          name: 'lmsCourses',
          params: { md: _mode, cnm: _name, type: _type, d1: _d1, d2: _d2 }
        });
      }
    },
    updateMngName(){
      request({
        api: { method: "POST", url: "v2/learn/updateMngName" },
        data: {
          mngFirstName: this.updateMngNameModal.mngFirstName,
          mngLastName: this.updateMngNameModal.mngLastName,
          userId: this.$store.state.user.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$bvToast.toast("Амжилттай", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true,
          });
          this.updateMngNameModal.show=false;
          //this.init();
          this.showCertificate( this.certificateModal.course);
          
        }
      });
    },

    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    onCertificateRe() {
      //console.log(this.$store.state.user.userId);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/learn/RemoveCertificateFile" },
        data: {
          id: this.certificateModal.course.id,
          userId: this.$store.state.user.userId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.showCertificate(this.certificateModal.course);
          this.$bvToast.toast("Амжилттай", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true
          });
        }
      });
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    loctypeCleared(){
      this.filterParams.type= null;
      this.$refs.stdnthdr.searchHandler();
      //this.filterKey++;
      //console.log('etssiin log');
    },
    toggleFilterDrawer() {
      this.filterParams.sideBar = true;
    },
    // subNavChange(e) {
    //   //this.filterParams.activeId= e;
    //   if (this.navbarMode == 1) {
    //     this.toggleNavbar(false);
    //   }

    //   this.$router.push({
    //     name: "lmsCourses",
    //     params: {
    //       md: e,
    //       cnm: this.$route.params.cnm,
    //       type: this.$route.params.type,
    //       d1: "null",
    //       d2: "null"
    //     }
    //   });
    // },
    loctypeSelectedWithdata(e){
      //console.log('loctypeSelectedWithdata=> ', e);
    },
    init() {
      if(this.$store.state.app.activeGroup.id===9358){
        this.listMode=3;
      }
      // console.log('=> courses init fired');

      let _url = "v2/Learn/GetCourses";
      switch (this.$route.params.md) {
        case 2:
        case "2":
          _url = "v2/Learn/getMustJoinCourseList";
          break;
        case 3:
        case "3":
        case 33:
        case "33":
          _url = "v2/Learn/myJoinedCourses";
          break;
        case 4:
        case "4":
        case 44:
        case "44":
          _url = "v2/Learn/myFinishedCourses";
          break;
        default:
          break;
      }

      let _academyCourse= null;
      if(this.$store.state.app.activeGroup.id == 9157) {
        if(this.$route.params.md == 11 || this.$route.params.md == 33 || this.$route.params.md == 44){
          _academyCourse= 1;
        } else {
          _academyCourse= 0;
        }
      }

      if (this.$route.params.cnm != "null") {
        this.filterParams.name = decodeURI(this.$route.params.cnm);
      }

      if (this.$route.params.d1 != "null" && this.$route.params.d2 != "null") {
        this.filterParams.date = [
          moment(this.$route.params.d1),
          moment(this.$route.params.d2)
        ];
        //this.filterParams.show = true;
      }

      if (this.$route.params.type > -1) {
        this.filterParams.type = this.$route.params.type;
      }

      // console.log('this.$route.params.type', this.filterParams.type, this.$route.params.type);

      if(localRead("course_filter_lc2")){
        this.filterParams.locTypeId2= parseInt(localRead("course_filter_lc2"), 10);
        if(localRead("course_filter_lc2_dta")){
          let _json =JSON.parse(localRead("course_filter_lc2_dta"));
          if(this.filterParams.locTypeId2>0 && this.filterParams.locTypeId2!='' && _json.length){
            //console.log(_json.filter(x=>x.id==this.filterParams.locTypeId2))
            let _jsonone= _json.filter(x=>x.id==this.filterParams.locTypeId2);
            if(_jsonone.length){
              Notification.warning({
                title: `${_jsonone[0]['title']}`,
                message: `Хайсан утга: ${_jsonone[0]['desc']}`,
                duration: 3000,
                type: "warning",
                position: "bottom-right",
                offset: 50
              });
            }            
          }
        }
      }

      this.fetching= true;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: _url },
        data: {
          skip: 0,
          size: 1000,
          name:
            this.$route.params.cnm != "null"
              ? decodeURI(this.$route.params.cnm)
              : null,
          startDate:
            this.$route.params.d1 != "null" ? this.$route.params.d1 : null,
          endDate:
            this.$route.params.d2 != "null" ? this.$route.params.d2 : null,
          locTypeId: this.filterParams.type,
          locTypeId1: null,
          locTypeId2: this.filterParams.locTypeId2,
          //joinOption: this.filterParams.type != null ? 1 : 0
          joinOption: 0,
          academyCourse: _academyCourse
        },
        store: this.$store
      }).then(res => {
        
        this.fetching= false;
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //this.courses = res.data.courses;
          console.log( '654321=> ', res.data.courses.length, _academyCourse, this.$route.params.md, _url );
          // res.data.courses = res.data.courses.map(e => Object.assign(e, { firstLessonId: 
          //   e.boxes.length && e.boxes.filter(x=>ot==114).length? e.boxes.filter(x=>ot==114)[0]['id'] : 0
          //   //,e.boxes.filter(x=>ot==114)[0]['id']
          // }));
          this.coursesRaw = res.data.courses;
          this.courses = res.data.courses;
          if(this.listMode===3){
            this.courses = _.orderBy(this.courses, ["locType.name"], ["asc"]);
          }

          if(this.$route.params.md == 2 && (this.$store.state.app.activeGroup.id == 9241 || this.$store.state.app.activeGroup.id == 9249)){
            this.initZaaval();
            //this.courses = this.courses.filter(x=>x.status == 1);
          }

          this.initCount();

          this.now = res.data.now;
          //console.log(_url+'=> ', res.data.courses, this.filterParams);
        }
      });

      // this.initCount();
    },
    changeListMode(m){
      if(m===3){
        this.courses = _.orderBy(this.courses, ["locType.name"], ["asc"]);
      }
      this.listMode= m;
    },
    initZaaval(){
      console.log('this.courses', this.courses.filter(x=>x.myShare !== null));
      this.zaaval.viewing = this.courses.filter(x=>x.myShare !== null && x.myShare.percent < 100).length;
      this.zaaval.notRegistered = this.courses.filter(x=>x.myShare === null).length;
      this.zaaval.completed = this.courses.filter(x=>x.myShare !== null && x.myShare.percent >= 100).length;
    },
    initCount() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Learn/GetCourseCounts" },
        data: {
          name: this.filterParams.name,
          locTypeId: this.filterParams.type,
          locTypeId2: this.filterParams.locTypeId2,
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.counts = res.data;
        }
      });
    },
    courseInfo(c) {
      if(this.$route.params.md == 3 || this.$route.params.md == 33){
        this.$router.push({ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } });
      } else if(this.$route.params.md == 1 || this.$route.params.md == 2 || this.$route.params.md == 11) {
        this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "V2/Learn/courseDetail" },
            params: { id: c.id },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log('res.data.course', res.data.course);
              this.course.obj = res.data.course;
              this.course.modal = true;
              this.course.infos = [];
              this.course.infos.push({
                id: 1,
                title: "Эхлэх огноо",
                value: moment(res.data.course.date.start).format("YYYY.MM.DD"),
                icon: "calendar"
              });
              this.course.infos.push({
                id: 2,
                title: "Дуусах огноо",
                value: moment(res.data.course.date.end).format("YYYY.MM.DD"),
                icon: "calendar"
              });
              this.course.infos.push({
                id: 3,
                title: "Сургалтын цаг:",
                value: res.data.course.time.toFixed(2) + " цаг",
                icon: "clock"
              });
              this.course.infos.push({
                id: 4,
                title: "Кредит оноо",
                value: res.data.course.creditPoint,
                icon: "clock"
              });

              if(res.data.course.hasExam){
                this.course.infos.push({
                  id: 5,
                  title: "Шалгалттай эсэх ",
                  value: res.data.course.hasExam ? "Тийм" : "Үгүй",
                  icon: "pen-tool"
                });
              }
              
              if(res.data.course.lessonExamCount>0){
                this.course.infos.push({
                  id: 6,
                  title: "Явцын шалгалт ",
                  value: res.data.course.lessonExamCount,
                  icon: "pen-tool"
                });
              }

              this.course.infos.push({
                id: 7,
                title: "Сертификаттай эсэх",
                value: res.data.course.certificateView == 1 ? "Тийм" : "Үгүй",
                icon: "award"
              });

              if(res.data.course.student.limitView == 1){
                this.course.infos.push({
                  id: 8,
                  title: "Оролцогчийн лимит",
                  value: `${res.data.course.student.count}/${res.data.course.student.limit}`,
                  icon: "users"
                });
              }

              this.course.lessons = [];
              let _lsns = res.data.course.boxes.filter(x => x.ot == 114);
              if (_lsns.length > 0) {
                this.course.lessons = _lsns[0].tasks;
              }
            }
          });
      }
    },
    onReset() {
      this.filterKey++;
      this.$router.push({
        name: "lmsCourses",
        params: {
          md: this.$route.params.md,
          cnm: "null",
          type: -1,
          d1: "null",
          d2: "null"
        }
      });
    },
    searchCourse() {
      // let _d1 = "null";
      // let _d2 = "null";
      // if (this.filterParams.date != "") {
      //   _d1 = moment(this.filterParams.date[0]).format("YYYY-MM-DD");
      //   _d2 = moment(this.filterParams.date[1]).format("YYYY-MM-DD");
      // }

      // //console.log(_d1, _d2, this.filterParams.type);

      // this.$router.push({
      //   name: "lmsCourses",
      //   params: {
      //     md: this.$route.params.md,
      //     cnm:
      //       this.filterParams.name != ""
      //         ? encodeURI(this.filterParams.name)
      //         : "null",
      //     type:
      //       this.filterParams.type == null ? "null" : this.filterParams.type,
      //     d1: _d1,
      //     d2: _d2
      //     // d1: 'null',
      //     // d2: 'null',
      //   }
      // });
    },
    getRemainingPercent(c) {
      var today = moment(this.now);
      var start = moment(c.startDate);
      var due = moment(c.endDate);
      return (
        (due.diff(today, "days") * 100) /
        due.diff(start, "days")
      ).toFixed(2);
    },
    getRemainingDays(c) {
      var today = moment(this.now);
      var due = moment(c.endDate);
      return due.diff(today, "days");
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    showCertificate(course) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "V2/Learn/CreateCertificateFromTemplate" },
        data: { id: course.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.certificateModal.course = course;

          if (res.data.file.id != 0) {
            this.certificateModal.show = true;
            
            this.certificateModal.url = res.data.file.url;
            this.certificateModal.title = course.name;
          } else {

            if (res.data.updateMngName) {
              this.updateMngNameModal.show = true;
              this.updateMngNameModal.mngFirstName = res.data.mngFirstName;
              this.updateMngNameModal.mngLastName = res.data.mngLastName;
            } else {
            this.$bvToast.toast(
              "Сертификат үүсгэхэд алдаа гарлаа. ахин оролдоно уу",
              {
                title: "Мэдэгдэл",
                autoHideDelay: 500,
                appendToast: true
              }            );
            }
          }
        }
      });
      //
    },
    showMark(course) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/learn/getCourseExamResult" },
        data: { id: course.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.courseExamResult.result = res.data.result;
          this.courseExamResult.show = true;
        }
      });
    },
    getScrollHeight() {
      let mh = 140;

      // if (screen.width <= 1024) {
      //   mh = 80;
      // } else {
      //   mh = this.filterParams.show ? 214 : 150;
      // }
      return `calc(${window.innerHeight}px - ${mh}px);`;
    },
    beforeJoinToCourse(c) {
      // if(this.$route.params.md == 3){
      //   this.$router.push({ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } });
      // } else if(this.$route.params.md == 1 || this.$route.params.md == 2) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "V2/Learn/courseDetail" },
          params: { id: c.id },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.directJoinToCourse(res.data.course, c.firstLessonId);
          }
        });
      //}
    },
    directJoinToCourse(e, firstLessonId) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskInUser/ShareTaskUser" },
        data: { userId: this.$store.state.user.userId, taskId: e.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          // if(firstLessonId>0){
          //   this.$router.push({
          //     name: "lmsLessonView",
          //     params: { id: firstLessonId, cid: e.id, bid: 0, iid: 0, bot: 0 }
          //   });
          // } else {
            this.$router.push({
              name: "lmsCourseView",
              params: { id: e.id, bid: 0, iid: 0, bot: 0 }
            });
          // }
          //console.log(res);
        }
      });
    },
    infModule(l) {
      this.mdlInf.obj= l;
      this.mdlInf.modal= true;
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      //console.log(newRoute, oldRoute);
      Object.assign(this.$data, this.$options.data());
      this.$nextTick(() => {
        this.init();
      });
    }
  }
};
</script>

<style></style>
